module.exports = __webpack_public_path__ + "img/GALLERY-SCROSS-4.4361e04c.jpg";